module.exports = __webpack_public_path__ + "img/hotwater.4ad0f7b4.svg";